import React, { useRef, useEffect } from "react"
import PropTypes from "prop-types"
function useOutsideClickDetect(ref, outSideAction = "") {
  /**
   * Alert if clicked on outside of element
   */
  function handleClickOutside(event) {
    if (ref.current && !ref.current.contains(event.target)) {
      if (typeof outSideAction === "function") {
        setTimeout(() => {
          outSideAction()
        }, 100)
      }
    }
  }

  useEffect(() => {
    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside)
    }
  })
}

/**
 * Component that alerts if you click outside of it
 */
function OutsideClick(props) {
  const wrapperRef = useRef(null)
  //console.log("TCL: OutsideClick -> wrapperRef", wrapperRef)
  useOutsideClickDetect(wrapperRef, props.outsideAction)
  return <div ref={wrapperRef}>{props.children}</div>
}

OutsideClick.propTypes = {
  children: PropTypes.element.isRequired,
}
export default OutsideClick
